import { WashingMachineOffIcon } from './WashingMachineOffIcon';

/**
 * author: Michael Irigoyen
 * id 9B318E52-E7BE-4BE1-94DF-96CA020CE55D
 * name washing-machine-off
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/washing-machine-off.svg
 * tags
 * - Home Automation 
 */
export const WasherOffIcon = WashingMachineOffIcon;
export default WasherOffIcon